import React from "react";
import styles from "./MatterDetails.module.scss";
import { Avatar } from "@progress/kendo-react-layout";
import EmailICon from "../../assets/email.png";
import PersonIcon from "../../assets/person.png";
import LocationICon from "../../assets/location.png";
import PhoneIcon from "../../assets/phone.png";

const NameAlias = (props) => {
  return (
    <Avatar
      type={"image"}
      shape={"circle"}
      className={`${styles["contact-avatar"]}`}
      style={{ cursor: "pointer" }}
    >
      <div className="d-flex align-items-center justify-content-center">
        {props.data}
      </div>
    </Avatar>
  );
};

export const ContactsListItem = ({ type, value }) => {
  switch (type) {
    case "email":
      return (
        <div className="d-flex align-items-center mb-2 mt-2">
          <div
            className={`${styles["white-circle"]} mb-1 me-4 d-flex justify-content-center align-items-center`}
          >
            <img src={EmailICon} alt="emailIcon"></img>
          </div>
          <div
            className={`${styles["detail-value"]}`}
            style={{ width: "max-content", overflow: "hidden" }}
          >
            {value}
          </div>
        </div>
      );
    case "phone":
      return (
        <div className="d-flex align-items-center mb-2 mt-2">
          <div
            className={`${styles["white-circle"]} mb-1 me-4 d-flex justify-content-center align-items-center`}
          >
            <img src={PhoneIcon} alt="phoneIcon"></img>
          </div>
          <div
            className={`${styles["detail-value"]}`}
            style={{ width: "max-content", overflow: "hidden" }}
          >
            {value}
          </div>
        </div>
      );
    case "location":
      return (
        <div className="d-flex align-items-center mb-2 mt-2">
          <div
            className={`${styles["white-circle"]} mb-1 me-4 d-flex justify-content-center align-items-center`}
          >
            <img src={LocationICon} alt="locationIcon"></img>
          </div>
          <div
            className={`${styles["detail-value"]}`}
            style={{ width: "max-content", overflow: "hidden" }}
          >
            {value}
          </div>
        </div>
      );
    case "person":
      return (
        <div className="d-flex align-items-center mb-1 mt-2">
          <div
            className={`${styles["white-circle"]} mb-1 me-4 d-flex justify-content-center align-items-center`}
          >
            <img src={PersonIcon} alt="personIcon"></img>
          </div>
          <div
            className={`${styles["detail-value"]}`}
            style={{ width: "max-content", overflow: "hidden" }}
          >
            {value}
          </div>
        </div>
      );
    default:
      break;
  }
  return {};
};

/**
 * @deprecated Use Tile from components/UIComponent/Tile.jsx
 */
export const ContainerCard = (props) => {
  return (
    <div
      className={`${styles["container-shadow"]} ${props.className}`}
      style={{
        ...props.style,
        height: props.height,
        width: props.width,
      }}
    >
      {props.children}
    </div>
  );
};

/**
 * @deprecated Use PrimaryBadgeComponent from components/UIComponent/Badges.jsx
 */
export const PrimaryBadgeComponent = (props) => {
  return (
    <p
      className={`badge rounded-pill ${styles["primary-pill"]} ${props.className} p-2 py-1`}
    >
      {props.text}
    </p>
  );
};

/**
 * @deprecated Use SecondaryBadgeComponent from components/UIComponent/Badges.jsx
 */
export const CategoryBadgeComponent = (props) => {
  return (
    <p
      className={`badge rounded-pill ${styles["category-pill"]} ${props.className} py-1`}
    >
      {props.text}
    </p>
  );
};
